module.exports = {"en":{"modules":{"panelmenu":{"tabbarTitle":"Menu","misc":{"gmb":{"title":"powered by"}}}}}}